
import { User, UserRole, UserStatus } from '../types';

/**
 * Bara bilder användaren själv laddat upp. Tidigare fick alla utan bild en
 * adress till ui-avatars.com — en extern tjänst som fick varje namn, och som
 * visade en trasig bild när den inte svarade. Nu visas initialer i stället.
 */
const ownAvatar = (url?: string | null): string | undefined =>
    url && !url.includes('ui-avatars.com') ? url : undefined;

export const DEFAULT_VALIDITY_DAYS = 360;

// Legacy debug helper
export const debug = (action: string, details: string) => {
    logAuthStep(action, "Info", details, 'info');
};

// New structured logger for DbStatus
export const logAuthStep = (step: string, expected: string, received: string, status: 'success' | 'error' | 'warning' | 'info' = 'info') => {
    // Felsökningslogg för inloggningsflödet — innehåller e-postadresser och
    // ska aldrig skickas ut i produktion.
    if (!import.meta.env.DEV) return;
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('auth-log', { 
            detail: { step, expected, received, status, ts: Date.now() } 
        }));
    }
};

export const mapUser = (row: any): User => ({
  id: row.id,
  name: row.name || 'Namnlös',
  email: row.email || '',
  role: (row.role?.toUpperCase() as UserRole) || UserRole.STUDENT,
  status: (row.status as UserStatus) || 'ACTIVE',
  validUntil: row.valid_until ? new Date(row.valid_until).getTime() : (Date.now() + (DEFAULT_VALIDITY_DAYS * 24 * 60 * 60 * 1000)),
  classId: row.class_id,
  assignedClassId: row.assigned_class_id,
  uniqueSlug: row.unique_slug,
  avatarUrl: ownAvatar(row.avatar_url),
  deletedAt: row.deleted_at ? new Date(row.deleted_at).getTime() : undefined,
  swishNumber: row.swish_number || undefined,
  requestedGroup: row.requested_group || undefined,
  createdAt: row.created_at ? new Date(row.created_at).getTime() : undefined
});

export const mapSessionUser = (authUser: any): User => {
    const meta = authUser.user_metadata || {};
    const email = authUser.email || '';
    const fallbackName = email.split('@')[0] || 'Användare';
    
    return {
        id: authUser.id,
        name: meta.name || fallbackName,
        email: email,
        role: (meta.role?.toUpperCase() as UserRole) || UserRole.STUDENT, 
        status: (meta.status as UserStatus) || 'ACTIVE', 
        validUntil: (Date.now() + (DEFAULT_VALIDITY_DAYS * 24 * 60 * 60 * 1000)), 
        classId: meta.classId || undefined,
        assignedClassId: meta.assignedClassId || undefined,
        uniqueSlug: meta.uniqueSlug || undefined,
        avatarUrl: ownAvatar(meta.avatarUrl)
    };
};
